import analytics from '../analytics'

export function userAccountRegister (apiClient, cognitoId, emailAddress) {
  const pathTemplate = '/register'
  const method = 'POST'
  const params = {}
  const additionalParams = {}
  const body = {
    cognitoId,
    emailAddress
  }

  console.log('Calling %s on %s', method, pathTemplate)
  var start = analytics.currentTime()
  return apiClient.invokeApi(params, pathTemplate, method, additionalParams, body)
    .then((result) => {
      var end = analytics.currentTime()
      analytics.time('API', 'retrieve-user', end - start, 'success')
      return result.data
    })
    .catch((error) => {
      var end = analytics.currentTime()
      analytics.time('API', 'retrieve-user', end - start, 'error')
      console.log('Error retrieving user account %j', error)
      throw error
    })
}

export function userAccountUpdate (apiClient, accountInfo) {
  const pathTemplate = '/user'
  const method = 'POST'
  const params = {}
  const additionalParams = {}
  const body = accountInfo

  console.log('Calling %s on %s', method, pathTemplate)
  var start = analytics.currentTime()
  return apiClient.invokeApi(params, pathTemplate, method, additionalParams, body)
    .then((result) => {
      var end = analytics.currentTime()
      analytics.time('API', 'update-user', end - start, 'success')
      return result.data
    })
    .catch((error) => {
      var end = analytics.currentTime()
      analytics.time('API', 'update-user', end - start, 'success')
      console.log('Error retrieving user account %j', error)
      throw error
    })
}



// WEBPACK FOOTER //
// ./src/api/user.js